import React, { FC, memo, ReactNode, useEffect, useState } from 'react'
import * as Styled from './styled'

interface LabeledInputWithCopyProps {
  label?: string
  children: ReactNode
  value?: string
}

export const LabeledInputWithCopy: FC<LabeledInputWithCopyProps> = memo(
  ({ label, children, value }: LabeledInputWithCopyProps) => {
    const [isCopied, setIsCopied] = useState(false)
    const handleCopy = (text: string) => {
      navigator.clipboard.writeText(text)
      setIsCopied(true)
    }

    useEffect(() => {
      if (isCopied) {
        setTimeout(() => {
          setIsCopied(false)
        }, 500)
      }
    }, [isCopied])
    return (
      <Styled.Labeled
        label={label}
        onRightButtonClick={() => handleCopy(String(value))}
        rightContent={
          <Styled.Copy>{isCopied ? 'copied!' : 'copy'}</Styled.Copy>
        }
      >
        {children}
      </Styled.Labeled>
    )
  }
)

LabeledInputWithCopy.displayName = 'LabeledInputWithCopy'
